/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Email entity
 * @export
 * @interface TravelineBookingPersonEmailDto
 */
export interface TravelineBookingPersonEmailDto {
    /**
     * Email
     * @type {string}
     * @memberof TravelineBookingPersonEmailDto
     */
    emailAddress: string;
}

/**
 * Check if a given object implements the TravelineBookingPersonEmailDto interface.
 */
export function instanceOfTravelineBookingPersonEmailDto(value: object): value is TravelineBookingPersonEmailDto {
    if (!('emailAddress' in value) || value['emailAddress'] === undefined) return false;
    return true;
}

export function TravelineBookingPersonEmailDtoFromJSON(json: any): TravelineBookingPersonEmailDto {
    return TravelineBookingPersonEmailDtoFromJSONTyped(json, false);
}

export function TravelineBookingPersonEmailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineBookingPersonEmailDto {
    if (json == null) {
        return json;
    }
    return {
        
        'emailAddress': json['emailAddress'],
    };
}

  export function TravelineBookingPersonEmailDtoToJSON(json: any): TravelineBookingPersonEmailDto {
      return TravelineBookingPersonEmailDtoToJSONTyped(json, false);
  }

  export function TravelineBookingPersonEmailDtoToJSONTyped(value?: TravelineBookingPersonEmailDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'emailAddress': value['emailAddress'],
    };
}

